module.exports = __webpack_public_path__ + "Icono_DisponibilidadEquipos_126px.png";